export const ENABLE_PARTNER_AD_LISTING_CAMPAIGNS =
  'enablePartnerAdListingCampaigns';
